import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  `

export const Children = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 82px);
`